import $ from "jquery";
import { markHeaderSearchForLogging } from "../../../shared/searchActivityStorage";

$(function () {
    $("form").has("input[type='search'][name='q']").on("submit", markHeaderSearchForLogging);

    $(".search-input[data-url]").each(function () {
        const $searchInput = $(this) as JQuery<HTMLInputElement>;
        const $searchInputForm = $searchInput.closest("form");
        $searchInputForm.on("submit", function (event: JQuery.SubmitEvent) {
            event.preventDefault();
            markHeaderSearchForLogging();
            const term = $searchInput.val()?.toString();
            window.location.href = `${$searchInputForm.attr("action")}?q=${encodeURIComponent(term as string)}`;
        });
    });

    const $searchTrigger = $(".search-trigger");
    const $searchBox = $(".search-box");
    const $searchIcon = $("#search-trigger .search-icon");
    const $closeIcon = $("#search-trigger .close-icon");

    $searchTrigger.on("click", function () {
        if (document.startViewTransition) {
            document.startViewTransition(() => {
                toggleSearchBox();
            });
        } else {
            toggleSearchBox();
        }
    });

    $(document).on("click", function (event: JQuery.ClickEvent) {
        if (
            !$searchBox.is(event.target as Element) &&
            $searchBox.has(event.target as Element).length === 0 &&
            !$searchTrigger.is(event.target as Element) &&
            !$searchBox.hasClass("hidden")
        ) {
            hideSearchBox();
        }
    });

    $(document).on("keydown", function (event: JQuery.KeyDownEvent) {
        if (!$searchBox.hasClass("hidden") && event.key === "Escape") {
            hideSearchBox();
        }
    });

    function toggleSearchBox() {
        const isHidden = $searchBox.hasClass("hidden");
        $searchBox.toggleClass("hidden");
        $searchBox.attr("aria-expanded", isHidden.toString());
        $searchIcon.toggleClass("hidden");
        $closeIcon.toggleClass("hidden");

        // Focus the search input when opening the search box
        if (isHidden) {
            const $searchInput = $searchBox.find("[type='search']");
            if ($searchInput.length > 0) {
                $searchInput.focus();
            }
        }
    }

    function hideSearchBox() {
        $searchBox.addClass("hidden");
        $searchBox.attr("aria-expanded", "true");
        $searchIcon.toggleClass("hidden");
        $closeIcon.toggleClass("hidden");
    }
});
